export const DEFAULT_PATTERN = [
  'src/**/__workshop__/index.js',
  'src/**/__workshop__/index.jsx',
  'src/**/__workshop__/index.ts',
  'src/**/__workshop__/index.tsx',
]
